export default __webpack_public_path__ + "static/media/ac-close.a4d73559.svg";